<template>
  <div id="wrap-header">
    <b-navbar toggleable="sm" type="dark" variant="#fff" class="pop">
      <b-navbar-brand class="web-header-logo" to="/">
        <b-img
          src="../assets/images/index/nav_logo1.png"
          alt=""
          class="logo-img"
          @click="goIndex"
        />
      </b-navbar-brand>

      <!-- <b-navbar-toggle target="nav-collapse" class="nav-menu" > -->
      <b-navbar-toggle target="nav-collapse-none" class="nav-menu">
        <span>
          <img
            src="../assets/images/m_close.png"
            alt=""
            v-if="PcFlag == false && subNavData.length"
            @click="close"
          />
          <!-- <img src="../assets/images/m_close.png" alt=""  v-if="PcFlag==false"> -->
          <img
            v-else
            src="../assets/images/m_more.png"
            alt=""
            @click="showSubMenu"
          />
        </span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            href="#"
            class="nav-item text-right smwidth-auto"
            v-for="(item, index) in menuList"
            :key="index"
            :to="item.url"
            exact
            exact-active-class="active"
            @mouseleave="handleNavLeave"
            @mouseenter="handleNavHover(item.sonList, index)"
            @click="activeMenu(index, item.url)"
          >
            <div class="pc" v-if="PcFlag">
              <span
                :class="[
                  current == index ||
                  (current == null && currentActive == index)
                    ? 'spanClass'
                    : '',
                ]"
                >{{ item.name }}</span
              >
            </div>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="subNav" v-if="PcFlag && showSubNav && subNavData.length">
      <b-container fluid>
        <b-row
          class="justify-content-sm-end nav-header nav-box"
          @mouseleave="handleNavLeave"
          @mouseenter="handleNavHover(-1)"
          :style="{ 'padding-right': cptSubRight() + '%' }"
        >
          <b-col
            cols="3"
            sm="auto"
            v-for="(item, index) in subNavData"
            :key="item.id"
            class="col-item"
          >
            <!-- :span="Math.floor(24 / subNavData.length)" -->
            <span
              class="item-sub"
              @click="goPcPage(item, index)"
              :class="[
                current === currentActive && currentSub === index
                  ? 'spanColor'
                  : '',
              ]"
              >{{ item.name }}</span
            >
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="phonemenu" v-if="PcFlag == false && subNavData.length">
      <ul>
        <li v-for="(item, index) in menuList" :key="index" class="item-li">
          <div class="fumenu">
            <span
              @click="goPage(item, item.url)"
              :class="[currentBg == item.url ? 'subClass' : '']"
            >
              {{ item.name }}
            </span>
          </div>

          <b-container fluid class="sonmenu">
            <b-row class="d-flex">
              <b-col
                style="margin: 0 3px"
                cols="auto"
                v-for="(v, i) in item.sonList"
                :key="i"
                @click="goPage(v, v.url)"
              >
                <span :class="[currentBg == v.url ? 'subClass' : '']">
                  {{ v.name }}
                </span>
              </b-col>
            </b-row>
          </b-container>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  name: "Header",
  data() {
    return {
      dataMenu: [],
      menuList: [],
      showSubNav: false,
      subNavData: [],
      hoverTimer: null,
      screenWidth: 0,
      PcFlag: true,
      current: null, //nav 当前hover的,不hover时候是null
      pcSub: "",
      currentBg: "",
      currentSub: "",
      currentActive: "", //当前激活的subNav对应的nav
    };
  },
  created() {
    this.getMenu();

    if (sessionStorage.getItem("currentNavData")) {
      let currentNavData = JSON.parse(sessionStorage.getItem("currentNavData"));

      this.currentActive = currentNavData.currentActive;
      this.currentSub = currentNavData.currentSub;

      // console.log("yy", currentNavData);
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem(
        "currentNavData",
        JSON.stringify({
          currentActive: this.currentActive,
          currentSub: this.currentSub,
        })
      );
    });
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    this.setReSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setReSize();
    };
  },
  methods: {
    cptSubRight() {
      return this.subNavData.length <= 4 ? 15 : 0;
    },
    goIndex() {
      this.currentActive = 0;
      this.currentSub = null;
      this.close();
      this.reload();
    },
    setReSize() {
      if (this.screenWidth >= 576) {
        this.PcFlag = true;
      } else {
        // this.PcFlag = false;
      }
      // console.log(
      //   "77",
      //   this.current,
      //   this.$route,
      //   "?",
      //   this.currentBg,
      //   "<",
      //   this.showSubNav,
      //   this.subNavData,
      //   this.showSubNav && this.subNavData.length
      // );
    },
    activeMenu(index, url) {
      this.current = index;
      this.currentBg = url;

      // console.log("item", index, this.current);
    },
    getMenu() {
      this.dataMenu = [
        {
          id: "01",
          url: "",
          name: "中心概况",
          sonList: [
            // { id: "101", name: "中心简介", url: "/" },
            { id: "101", name: "中心简介", url: "/about-us/about-us" },
            // { id: "102", name: "中心领导", url: "/about-us/leading" },
            { id: "103", name: "机构设置", url: "/about-us/organization" },
            { id: "104", name: "荣誉资质", url: "/about-us/honor" },
            { id: "105", name: "党建之窗", url: "/about-us/Departments" },
            { id: "106", name: "中心动态", url: "/about-us/new-center" },
            { id: "107", name: "联系我们", url: "/about-us/contact-us" },
          ],
        },
        {
          id: "02",
          url: "",
          name: "数字政府",
          sonList: [
            { id: "201", name: "智慧政务", url: "/e-gov/wisdom-gov" },
            { id: "202", name: "核心服务", url: "/e-gov/core-service" },
            { id: "203", name: "软著与专利", url: "/e-gov/project-search" },
            { id: "204", name: "行业标准编制", url: "/e-gov/industrial" },
          ],
        },
        {
          id: "03",
          url: "/digital-ecology/digital-ecology",
          name: "数字生态",
          sonList: [],
        },
        {
          id: "04",
          name: "人才招聘",
          url: "/job-find/job-find",
          sonList: [],
        },
      ];
      this.menuList = this.dataMenu;
      this.menuList.forEach((item) => {
        this.subNavData.push(item.sonList);
      });

      // console.log("213-jinla", this.subNavData);
    },
    close() {
      this.subNavData = [];
    },
    open() {
      (this.subNavData = []), (this.menuList = []);
      this.menuList = this.dataMenu;
      this.menuList.forEach((item) => {
        this.subNavData.push(item.sonList);
      });
    },
    goPcPage(item, index) {
      this.currentSub = index;
      this.currentActive = this.current;
      if (item.url) {
        this.$router.push({
          path: item.url,
        });
        // this.subNavData = [];
      }
      // console.log("234", this.$route.path);
      this.currentBg = this.$route.path ? this.$route.path : this.currentBg;
    },
    goPage(item, url) {
      if (item.url) {
        this.$router.push({
          path: item.url,
        });
        // this.subNavData = [];
      }
      // if(url){
      // }
      this.currentBg = url || null;
      this.close();
    },

    handleNavHover(value, index) {
      clearTimeout(this.hoverTimer);
      // console.log("???", value);
      if (value != -1) {
        this.subNavData = value;
      }
      this.showSubNav = true;

      this.current = index != undefined ? index : this.current;
      // console.log("this", this.current);
      // console.log("fff", index, this.PcFlag, this.$route.path);
      // console.log("fff",index,this.PcFlag , this.showSubNav , this.subNavData.length);
      if (this.$route.path) {
        this.PcFlag = true;
        this.pcSub = this.$route.path;
      }
    },
    handleNavLeave() {
      console.log("cur", this.current);

      this.hoverTimer = setTimeout(() => {
        this.showSubNav = false;
        this.current = null;
      }, 1000);
    },
    showSubMenu() {
      console.log("this21", this.$route);

      this.currentBg = this.$route.path ? this.$route.path : this.currentBg;
      this.PcFlag = false;
      this.open();
    },
  },
};
</script>
<style>
@import "../assets/css/header.css";
</style>
